module.exports = __webpack_public_path__ + "img/9788971994931.a6a181b5.jpg";